import angular from "angular";
import { vsModuleName as sharedContractModuleName } from "../../../Contract/shared";
import {
  registerContracts,
  registerMachineDetailGamingContractTab,
} from "./registerContracts";
import { vsModuleName as contractConfigModuleName } from "./configs/module";

import {
  gamingContractDetailComponentOptions,
  vsComponentName as gamingContractDetailComponentName,
} from "./components/types/gamingContract/detail";

import {
  gamingContractMasterAgreementDetailComponentOptions,
  vsComponentName as masterAgreementDetailComponentName,
} from "./components/types/gamingContractMasterAgreement/detail";
import {
  contractAmendmentsComponentOptions,
  vsComponentName as contractAmendmentsComponentName,
} from "../../../Contract/shared/components/amendments/component";
import {
  amendmentDetailComponentOptions,
  vsComponentName as amendmentDetailComponentName,
} from "../../../Contract/shared/components/amendments/detail";
import {
  changeJournalContractAmendmentComponentOptions,
  vsComponentName as changeJournalContractAmendmentComponentName,
} from "../../../Contract/shared/changeJournal/contractAmendment";
import {
  ChangeJournalViewItemServiceProvider,
  vsProviderName as ChangeJournalViewItemServiceProviderName,
} from "../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail";

import { vsObjectName as gamingContractMasterAgreementAmendmentName } from "./configs/gamingContractMasterAgreementAmendment";
import {
  ChangeJournalObject,
  ChangeJournalObjectIdentifier,
} from "../../../records/changeJournal/changeJournalViewComponent/models";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ServiceResponse } from "../../../records/server/query";
import { Record } from "../../../records/server/crud";

export const vsModuleName = "Contracts.CacheCreek";

angular
  .module(vsModuleName, [sharedContractModuleName, contractConfigModuleName])
  .config(registerContracts)
  .config(registerMachineDetailGamingContractTab)
  .component(
    gamingContractDetailComponentName,
    gamingContractDetailComponentOptions
  )
  .component(
    masterAgreementDetailComponentName,
    gamingContractMasterAgreementDetailComponentOptions
  )
  .component(
    contractAmendmentsComponentName,
    contractAmendmentsComponentOptions
  )
  .component(amendmentDetailComponentName, amendmentDetailComponentOptions)
  .component(
    changeJournalContractAmendmentComponentName,
    changeJournalContractAmendmentComponentOptions
  )
  .config([
    ChangeJournalViewItemServiceProviderName,
    (
      changeJournalViewItemServiceProvider: ChangeJournalViewItemServiceProvider
    ) => {
      changeJournalViewItemServiceProvider.addTypeComponent(
        gamingContractMasterAgreementAmendmentName,
        {
          componentName: changeJournalContractAmendmentComponentName,
          resolveInfoSref: (o) => ({
            sref: "main.contract.type.info.amendments",
            params: {
              id: o.object.GamingContractMasterAgreementAmendmentId,
              amendmentId: o.id.ObjectId,
            },
          }),
          resolveObjects: [
            "objectIdentifier",
            ServerUtilityName,
            (
              objectIdentifier: ChangeJournalObjectIdentifier,
              serverUtility: ServerUtility
            ) =>
              serverUtility
                .getById<ServiceResponse<Record[]>>({
                  id: objectIdentifier.ObjectId,
                  url: `/api/contract/masterAgreement/amendments`,
                })
                .then((r): ChangeJournalObject[] => [
                  {
                    id: objectIdentifier,
                    object: r.Result,
                  },
                ]),
          ],
        }
      );
    },
  ]);
